module.exports = __webpack_public_path__ + "static/media/notifications-like.077f5e52.svg";